import { Component, OnInit } from '@angular/core';
import { Title }     from '@angular/platform-browser';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router,ActivatedRoute, NavigationEnd} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/features/services/auth/auth.service';
import { environment } from 'src/app/environments/environments';
import { ToolsService } from 'src/app/shared/services/tools.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { RemoteApiService } from 'src/app/shared/services/remote-api.service';
import { MyErrorStateMatcher } from 'src/app/shared/app-classes';
import { FacebookAuthProvider, GoogleAuthProvider } from 'firebase/auth';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { LoggingService } from 'src/app/shared/services/Logging.service';
declare let amazon: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
  
})
export class LoginComponent implements OnInit {
  InProgress: boolean=false;
  matcher = new MyErrorStateMatcher();
  loginForm: FormGroup;
  submitted : any  ;
  token: string | undefined;
  previousUrl: any  ;
  currentUrl: any ;
  preURL : any
  previous_url: any
  private clientId = environment.amazonSDK.ClientID;
constructor(
    private RAS: RemoteApiService,
    private tools:ToolsService,
    private urlService: UrlService,
    private titleService: Title,
    private auth: AuthService,
    private loggingService: LoggingService,
    private router: Router,
    public snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private afs : AngularFirestore) { 
      this.route.params.subscribe((params) => {
        this.token = params['token'];
       });
      this.loginForm  = new FormGroup ({
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', [Validators.required]),
        rememberMe:new FormControl()
      });
      if(this.token){
      this.InProgress=true

        let body={
					"state":this.token
				}
         
       }
      this.titleService.setTitle( 'Login' ); 
      window.history.pushState({ prevUrl: window.location.href }, '' )
}
ngAfterViewInit(): void {
  this.loginInit();
}
private loginInit() {
  if (this.clientId == null) {
    throw new Error(
      'clientId property is necessary. (<amazon-login [clientId]="..."></amazon-login>)');
  }
   amazon.Login.setClientId(this.clientId);
}
login() {
  if (this.loginForm.valid) {
    const rememberMe = this.loginForm.controls['rememberMe'].value;
    this.auth.doEmailLogin(this.loginForm.controls['email'].value, this.loginForm.controls['password'].value, rememberMe).then(
      async (res : any) => {
        this.loggingService.log('res login',res)
            this.handleSuccessfulLogin(res)
        
      },
      (err) => {
        this.handleLoginError(err);
      }
    );
  } else {
    this.snackBar.open('make sure the form is valid!', '', { duration: 2000 });
  }
}


private handleSuccessfulLogin(res: any) {
  //this.loggingService.log('res handleSuccessfulLogin ',res)
  this.checkIfAdmin(res.user.multiFactor.user.uid).subscribe((isAdmin: boolean) => {
    this.loggingService.log('checkIfAdmin', isAdmin , this.tools.isNullOrUndefined(res));
    if (!this.tools.isNullOrUndefined(res) && isAdmin) {
      this.router.navigate([`/admin/users`]);
    } else {
      this.loggingService.log('no Admin');
      this.router.navigate(['/home']);
    }
  });
}

checkIfAdmin(uid: any): Observable<boolean> {
  this.loggingService.log('uid', uid);
  const docRef = this.afs.collection('users').doc(uid);
  return new Observable<boolean>(observer => {
    docRef.get().subscribe((doc) => {
      this.loggingService.log('doc.exists', doc.exists);
      if (doc.exists) {
        const user : any = doc.data();
        if(user.role === "SuperAdmin"){
          observer.next(true);
        }else{
          observer.next(false);
        }
      } else {
        observer.next(false);
      }
      observer.complete();
    });
  });
}
private handleLoginError(err: any) {
  this.loggingService.log(err)
  this.snackBar.open("impossible de s'authentifier ", '', {duration: 2000 });
}
hide = true;

signInWithFB() 
{
  this.auth.AuthLogin(new FacebookAuthProvider()).then(
    async (res : any) => {
      this.loggingService.log('resres',res)
      const docRef = this.afs.collection('users').doc(res.user.uid);

    
    docRef.get().subscribe((doc) => {
      if (doc.exists) {
          this.handleSuccessfulLogin(res);
      } else {
          this.auth.SetUserData(res.user,'facebook')
          this.router.navigate(['/auth/signup-details']);
      }
    });
    },
    (err) => {
      this.handleLoginError(err);
    }
  )
}
signInWithGoogle() 
{
  this.auth.AuthLogin(new GoogleAuthProvider()).then(
    async (res : any ) => {
      this.loggingService.log(res)
      const docRef = this.afs.collection('users').doc(res.user.uid);

      docRef.get().subscribe((doc) => {
        if (doc.exists) {
            this.handleSuccessfulLogin(res);
        } else {
            this.auth.SetUserData(res.user,'gmail')
            this.router.navigate(['/auth/signup-details']);
        }
      });
    },
    (err) => {
      this.handleLoginError(err);
    }
  )
}

signInWithAmazon()
{

  amazon.Login.authorize({
    scope:'profile', response_type: 'token'
  }, (response:any) => {
     this.loggingService.log(response)
    this.auth.doTokenLogin(response.access_token).then(res => { this.loggingService.log(res)})
    },
      (error:any) => {
        this.loggingService.log('erreur', error);
      });
  
  
    // this.loggingService.log(res)
    //  this.auth.doTokenLogin(res.authToken).then( (res) => {
    //   this.loggingService.log('res', res )
    //   // this.handleSuccessfulLogin(res);
    //  })

    
    }
    
    private startSession(token: string) {
      this.InProgress = true; // Show loading indicator
    
      this.auth.doTokenLoginShopify(token).then(
        (userData: any) => {
          this.InProgress = false; // Stop loading indicator
          this.loggingService.log('Token authenticated successfully:', userData);
    
          // Check user role and redirect
          if (userData.role === 'SuperAdmin') {
            this.loggingService.log('Redirecting to Admin Dashboard...');
            this.router.navigate(['/admin/dashboard']);
          } else {
            this.loggingService.log('Redirecting to User Home...');
            this.router.navigate(['/home']);
          }
        },
        (error) => {
          this.InProgress = false; // Stop loading indicator
          console.error('Error during session start:', error);
          this.snackBar.open('Failed to start session. Please try again.', '', {
            duration: 2000,
          });
        }
      );
    }
    
    
ngOnInit() {
  this.route.queryParams.subscribe((params) => {
    // Attempt to read the token from query parameters
    const token = params['CONVERSELL_SHOPIFY_TOKEN'];

    if (token) {
      this.loggingService.log('Token from query params:', token);
      this.startSession(token);
    }
  });
  this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd | any ) => {
    this.urlService.setPreviousUrl(this.previousUrl);
  });
}


}
